exports = module.exports = require("../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".-col-group-container{border-bottom:1px solid #ddd}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-7469e691!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/vue2-datatable-component/src/HeaderSettings/index.vue
// module id = 915
// module chunks = 2